var React = require( 'react' );
var createReactClass = require('create-react-class');
var { Editor } = require('@tinymce/tinymce-react');

var ContentEditor = createReactClass( {
    handleEditorChange: function(e) {
        this.props.onChange(e);
    },

	render: function () {
        return (
            <Editor
                apiKey="lt80nermhhiezyf9t5rk2d9b7hqm7x5cdmit83cckk0t9kpe"
                initialValue={this.props.payload}
                name={this.props.name}
                init={{
                height: 500,
                menubar: false,
                branding: false,
                plugins: [
                    'advlist autolink lists link image',
                    'charmap print preview anchor help',
                    'searchreplace visualblocks code',
                    'insertdatetime media table paste imagetools wordcount textpattern'
                ],
                textpattern_patterns: [
                    {start: '*', end: '*', format: 'italic'},
                    {start: '**', end: '**', format: 'bold'},
                    {start: '#', format: 'h1'},
                    {start: '##', format: 'h2'},
                    {start: '###', format: 'h3'},
                    {start: '####', format: 'h4'},
                    {start: '#####', format: 'h5'},
                    {start: '######', format: 'h6'},
                    {start: '1. ', cmd: 'InsertOrderedList'},
                    {start: '* ', cmd: 'InsertUnorderedList'},
                    {start: '- ', cmd: 'InsertUnorderedList'},
                    {start: '//brb', replacement: 'Be Right Back'}
                 ],
                toolbar:
                    'undo redo | formatselect | bold italic | ' +
                    'alignleft aligncenter alignright | forecolor ' +
                    'bullist numlist outdent indent image code | help'
                }}
                onEditorChange={this.handleEditorChange}
            />
        );
	}
});

module.exports = ContentEditor;


// WEBPACK FOOTER //
// ./src/common/routes/education/components/layout/editor.jsx